var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.01416C0.75 2.21924 2.20508 0.76416 4 0.76416H20C20.1212 0.76416 20.2375 0.812319 20.3232 0.898045L31.1161 11.6909C31.2018 11.7767 31.25 11.8929 31.25 12.0142V36.0142C31.25 37.8091 29.7949 39.2642 28 39.2642H4C2.20507 39.2642 0.75 37.8091 0.75 36.0142V4.01416Z",
    fill: "white",
    stroke: "#D0D5DD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.51416V8.01416C20 10.2233 21.7909 12.0142 24 12.0142H31.5",
    stroke: "#D0D5DD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.25f668ca35f651b6c85695a024e7eee7.svg";
export { ForwardRef as ReactComponent };